var SuperAdminModule = /** @class */ (function () {
    function SuperAdminModule() {
    }
    return SuperAdminModule;
}());
export { SuperAdminModule };
